import { render } from "./PaymentFail.vue?vue&type=template&id=4a7c5b84&scoped=true&lang=pug"
import script from "./PaymentFail.vue?vue&type=script&lang=js"
export * from "./PaymentFail.vue?vue&type=script&lang=js"

import "./PaymentFail.vue?vue&type=style&index=0&id=4a7c5b84&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7c5b84"]])

export default __exports__